import { DatePicker } from '@bjarkehs/react-nice-dates';
import { Alert, Card, Checkbox, Select, Stack, Text, TextInput } from "@mantine/core";
import { enGB } from 'date-fns/locale';
import { isUndefined } from 'lodash';
import { DateTime } from 'luxon';
import * as React from 'react';
import AvailabilitiesApi from '../../../data/api/availabilitiesApi';

interface IAvailabilitySimulator {
    personId: string;
    defaultStart: DateTime;
    shiftContext?: string;
}

const AvailabilitySimulator: React.FC<IAvailabilitySimulator> = (props) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<string | undefined>(undefined);

    const [isPersonAvailable, setIsPersonAvailable] = React.useState<boolean | undefined>(undefined);
    const [durationMinutes, setDurationMinutes] = React.useState<number>(30);
    const [startDate, setStartDate] = React.useState<DateTime>(props.defaultStart);
    const [onlyManual, setOnlyManual] = React.useState<boolean>(false);

    React.useEffect(() => {
        setIsLoading(true);
        setError(undefined);
        AvailabilitiesApi.isPersonAvailable({ person: props.personId, shiftContext: props.shiftContext, start: props.defaultStart, finish: props.defaultStart.plus({ minutes: durationMinutes }), onlyManual })
            .then((resp) => {
                setIsPersonAvailable(resp);
                setIsLoading(false);
            }).catch(er => {
                setError(er.message);
                setIsLoading(false);
            })
    }, [props.personId, startDate, onlyManual, durationMinutes]);

    return (
        <Card style={{ padding: "20px", marginBottom: "20px" }}>
            <h4>Availability Simulator</h4>
            {error && <Alert color="red">{error}</Alert>}
            <DatePicker
                date={startDate?.toJSDate()}
                onDateChange={(date) => {
                    if (!date) return;
                    setStartDate(startDate.set({ year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }))
                }}
                locale={enGB}
            >
                {({ inputProps, focused }) => (
                    <TextInput
                        {...inputProps}
                        type="text"
                        className={`input${focused ? " -focused" : ""}`}
                        style={{ width: "50%" }}
                    />
                )}
            </DatePicker>
            {/* time picker */}
            <TextInput type="time" name="time" id="availsim-time-select" value={startDate?.toFormat('HH:mm')}
                style={{ width: "50%" }} onChange={(e) => {
                    const [hours, minutes] = e.target.value.split(':').map(Number);
                    setStartDate(startDate.set({ hour: hours, minute: minutes }))
                }}
            />


            <Select
                id="availsim-duration-select"
                style={{ width: "50%" }}
                onChange={(value) => setDurationMinutes(parseInt(value || "15"))}
                data={[15, 30, 45, 60, 90, 120].map((m) => ({
                    value: m.toString(),
                    label: `${m} minutes`
                }))}
            />
            <Stack gap="sm" style={{ paddingLeft: "40px" }}>
                <Checkbox
                    id="availsim-onlyManual-checkbox"
                    onChange={(e) =>
                        setOnlyManual(e.target.checked)
                    }
                    checked={onlyManual}
                    style={{ marginLeft: "-1em" }}
                />
                <label
                    htmlFor="availsim-onlyManual-checkbox"
                    className="fw-semibold"
                    style={{
                        color: "var(--color-text-disabled)",
                        marginLeft: "1em",
                        marginTop: "7px",
                    }}
                >
                    Only manually added availabilities (ignore appointments)
                </label>
            </Stack>

            <Alert style={{ marginTop: "20px" }} color={isPersonAvailable ? 'success' : 'error'}>
                {!isUndefined(isPersonAvailable) && isPersonAvailable ? 'YES: they ARE available' : 'NO: they are NOT available'} at {startDate?.toLocaleString(DateTime.DATETIME_MED)} for {durationMinutes} minutes.
            </Alert>

        </Card>
    );

}


export default AvailabilitySimulator;
